import React, { Component } from "react";
import queryString from "query-string";
import { Result, Descriptions } from "antd";
import { PostData } from "../api/service";
import OnlineMethod from "../Components/Payment/OnlineMethod";
import ServiceGate from "../Components/ServiceGate";

class AdmissionPrintPaymentPage extends Component {
  state = {
    admission_print_request_id: "",
    email: "",
    isLoaded: false,
    status: null,
    data: null,
    errorMessage: ""
  };

  componentDidMount() {
    const search = this.props.history.location.search;
    const searchData = queryString.parse(search);

    if (searchData && searchData.admission_print_request_id && searchData.email) {
      this.setState(
        {
          admission_print_request_id: searchData.admission_print_request_id,
          email: searchData.email
        },
        () => this.loadRequest()
      );
    } else {
      this.setState({
        isLoaded: true,
        status: false,
        errorMessage: "Missing request id or email in the URL."
      });
    }
  }

  loadRequest = () => {
    PostData("/get-admission-print-request-for-payment", {
      admission_print_request_id: this.state.admission_print_request_id,
      email: this.state.email
    })
      .then((resp) => {
        if (resp && resp.status === true && resp.data) {
          this.setState({ isLoaded: true, status: true, data: resp.data });
        } else {
          this.setState({
            isLoaded: true,
            status: false,
            errorMessage:
              "Request not found. Please verify the link from your email."
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          status: false,
          errorMessage: "Something went wrong. Please try again later."
        });
      });
  };

  renderBody() {
    const { data } = this.state;
    const fee = parseFloat(data.registration_fee) || 0;
    const paid = parseInt(data.payment_status, 10) === 1;

    if (paid) {
      return (
        <Result
          status="success"
          title="Payment already completed"
          subTitle={`Your reprint request (Ref #${data.id}) has been paid. Collect the reprinted receipt from the college office.`}
        >
          <Descriptions column={1} bordered={true} size="small">
            <Descriptions.Item label="Applicant">
              <strong>{data.name}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Roll No">{data.roll_no}</Descriptions.Item>
            <Descriptions.Item label="Receipt No">{data.receipt_no}</Descriptions.Item>
            <Descriptions.Item label="Amount Paid">
              &#8377; {data.amount_paid}
            </Descriptions.Item>
            <Descriptions.Item label="Paid On">
              {data.amount_paid_on}
            </Descriptions.Item>
          </Descriptions>
        </Result>
      );
    }

    if (fee <= 0) {
      return (
        <Result
          status="warning"
          title="No fee configured"
          subTitle="The reprint fee has not been set. Please contact the college office."
        />
      );
    }

    return (
      <ServiceGate service="admission_print">
        <div>
          <Descriptions column={1} bordered={true} size="small">
            <Descriptions.Item label="Applicant">
              <strong>{data.name}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Roll No">{data.roll_no}</Descriptions.Item>
            <Descriptions.Item label="Receipt No">{data.receipt_no}</Descriptions.Item>
            <Descriptions.Item label="Receipt Date">{data.receipt_date}</Descriptions.Item>
            <Descriptions.Item label="Applied For">{data.type_name}</Descriptions.Item>
            <Descriptions.Item label="Amount Payable">
              &#8377; {fee}
            </Descriptions.Item>
            <Descriptions.Item label="Email">{data.email}</Descriptions.Item>
            <Descriptions.Item label="Phone">{data.phone}</Descriptions.Item>
          </Descriptions>
          <br />
          <OnlineMethod
            endpoint="/getpaymentstringadmissionprint"
            payload={{
              admission_print_request_id: this.state.admission_print_request_id,
              email: this.state.email
            }}
            amount={fee}
          />
        </div>
      </ServiceGate>
    );
  }

  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  Receipt Reprint Fee Payment
                </div>
              </h3>
              <hr />

              {!this.state.isLoaded && <div>Loading . . . Please wait</div>}

              {this.state.isLoaded && this.state.status === true && this.renderBody()}

              {this.state.isLoaded && this.state.status === false && (
                <Result
                  status="error"
                  title="Unable to load payment"
                  subTitle={this.state.errorMessage}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdmissionPrintPaymentPage;
